import { useMerchant } from "@auth";
import { DropdownItem } from "@components";
import { cn } from "@utils";

export function MerchantSwitcher() {
  const { memberships, merchant, switchMerchant, loading } = useMerchant();

  if (loading || memberships.length <= 1) {
    return null;
  }

  return (
    <>
      {memberships
        .sort((a, b) => a.merchantName.localeCompare(b.merchantName))
        .map((m) => (
          <DropdownItem
            key={m.id}
            onClick={() => switchMerchant(m)}
            closeOnComplete={true}
            className={cn(
              "flex items-center px-3 py-2 text-sm",
              merchant?.id === m.merchantId
                ? "bg-blue-50 text-blue-700 font-medium"
                : "text-gray-700 hover:bg-gray-50",
            )}
          >
            <div className="w-6 h-6 mr-2 rounded-lg flex justify-center items-center text-white bg-blue-500 text-xs font-semibold shrink-0">
              {m.merchantName?.[0] || "M"}
            </div>
            <span className="truncate">{m.merchantName}</span>
            {merchant?.id === m.merchantId && (
              <span className="ml-auto text-blue-600">✓</span>
            )}
          </DropdownItem>
        ))}
      <div className="border-t border-gray-200 my-1"></div>
    </>
  );
}
